export const IMG_URL = process.env.REACT_APP_IMG_URL;

export const formatTime = (timeStr) => {
  if (!timeStr) return "N/A";
  const [hour, minute] = timeStr.split(":").slice(0, 2);
  const h = parseInt(hour, 10);
  const suffix = h >= 12 ? "PM" : "AM";
  const formattedHour = h % 12 === 0 ? 12 : h % 12;
  return `${formattedHour}:${minute} ${suffix}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "N/A";
  try {
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return dateStr;
    return date.toLocaleDateString("en-IN", {
      weekday: "short",
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export const normalizeDate = (dateStr) => {
  if (!dateStr) return "";
  try {
    const date = new Date(dateStr);
    if (Number.isNaN(date.getTime())) return "";
    return date
      .toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })
      .split("/")
      .join("-");
  } catch {
    return "";
  }
};

export const getTodayKey = () =>
  new Date()
    .toLocaleDateString("en-CA", { timeZone: "Asia/Kolkata" })
    .split("/")
    .join("-");

export const getFacilityImage = (image) => {
  if (!image) return null;
  return `${IMG_URL}${image}`;
};

export const getInitials = (name) => {
  if (!name?.trim()) return "U";
  return name
    .trim()
    .split(/\s+/)
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

export const getStatusMeta = (status) => {
  switch (status) {
    case "Success":
      return { label: "Completed", tone: "success", icon: "fa-circle-check" };
    case "Pending":
      return { label: "Pending", tone: "warning", icon: "fa-clock" };
    case "cancelled":
      return { label: "Cancelled", tone: "danger", icon: "fa-circle-xmark" };
    default:
      return {
        label: status || "Unknown",
        tone: "muted",
        icon: "fa-circle-question",
      };
  }
};

export const formatSlots = (slots, formatTimeFn = formatTime) => {
  if (!slots?.length) return "N/A";
  return slots
    .map((slot) => `${formatTimeFn(slot.start_time)} – ${formatTimeFn(slot.end_time)}`)
    .join(", ");
};
